export default __webpack_public_path__ + "static/media/camera-house-desktop-one.9976eb3a.png";